module.exports = __webpack_public_path__ + "static/media/logo_lvn.2a307b90.png";